module.exports = __webpack_public_path__ + "static/media/satya.30b80f7d.jpg";